<script setup>
defineProps({
    src: {
        type: String,
        default: '',
    },
    alt: {
        type: String,
        default: '',
    },
})
</script>

<template>
    <span class="rhdigital-logo-cell">
        <img v-if="src" :src="src" :alt="alt">
        <span v-else class="material-symbols-outlined">domain</span>
    </span>
</template>

<style lang="scss" scoped>
.rhdigital-logo-cell {
    display: inline-grid;
    place-items: center;
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #f3f0ff;
    color: #625bf6;

    img {
        width: 22px;
        height: 22px;
        object-fit: contain;
    }

    .material-symbols-outlined {
        font-size: 20px;
    }
}

.dark-theme {
    .rhdigital-logo-cell {
        background: rgba(98, 91, 246, 0.16);
        color: #9d98ff;
    }
}
</style>
